import * as React from 'react'
import {
  Show,
  TextField,
  BooleanField,
  TranslatableFields,
  SimpleShowLayout,
  NumberField,
  ListButton,
  TopToolbar,
  useGetIdentity,
} from 'react-admin'
import PropTypes from 'prop-types'

const ThematicShowActions = ({ identity, basePath }) => {
  let countryBasePath = ''
  if (identity.role !== 'admin') {
    countryBasePath = `${basePath}?filter={"country":"${identity.country}"}`
  }
  return (
    <TopToolbar>
      <ListButton basePath={countryBasePath} />
    </TopToolbar>
  )
}

ThematicShowActions.propTypes = {
  basePath: PropTypes.any,
  identity: PropTypes.any,
}

const ThematicShow = props => {
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <Show actions={<ThematicShowActions identity={identity} />} {...props}>
      <SimpleShowLayout>
        <NumberField source="id" />
        <BooleanField
          source="status"
          looseValue={true}
          valueLabelTrue="Active"
          valueLabelFalse="Not Active"
        />
        <TranslatableFields
          locales={['es', 'en', 'it', 'fr']}
          defaultLocale="es"
          source="label"
        >
          <TextField fullWidth source="label" />
        </TranslatableFields>
      </SimpleShowLayout>
    </Show>
  )
}

export default ThematicShow
